module.exports = __webpack_public_path__ + "img/faktury_inactive.06221126.svg";